export const SIDEBAR_WIDTH = 212;
export const SIDEBAR_SECTION_HEADER_HEIGHT = 22;
export const SIDEBAR_ITEM_HEIGHT = 28;
export const MOBILE_HEADER_HEIGHT = 48;
export const SIDEBAR_PADDING = 16;
